export const ACCOMMODATION_TYPE_CODE = {
  RESIDENCE: 'residence'
};
